import { ApiService } from '../shared/services/api-service/api.service';

class CancelReservationServiceClass {
    /**
     * Method to cancel reservation
     * @param hotelCode
     * @param reservationCode
     * @param lastName
     */
    async cancelReservation(hotelCode: number, reservationCode: number, lastName: string) {
        try {
            const retrieveReservationApiResponse: Response = await ApiService.cancelReservation(hotelCode, reservationCode, lastName);
            let response = '';
            if (retrieveReservationApiResponse.status !== 204) {
                response = await retrieveReservationApiResponse.json();
            }
            return response;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const CancelReservationService = new CancelReservationServiceClass();
